import { useBambooUserGetInfoQuery } from '@/gql/generated';
import { TCurrentUser } from '@/types/auth/auth.type';

export const useCurrentUser = (accessTokenRefresh: boolean = true) => {
  const { data, isLoading, refetch, isPending } = useBambooUserGetInfoQuery(
    {},
    {
      enabled: accessTokenRefresh,
      select: (response): TCurrentUser => {
        const user = response.bamboo_user_get_info;
        return {
          whmcs_id: user?.whmcs_id ?? undefined,
          time_zone: user?.time_zone ?? undefined,
        };
      },
    },
  );

  return { data, isLoading, refetch, isPending };
};
